<template>
  <div id="archive" ref="archive">
    <div v-for="episode in shows.slice().reverse()" :key="episode.number" class="episodeblock" :id="episode.number" >
      <div id="item" :class="{ mobile : isMobile }">
        <!-- <h1>{{ episode.date }}</h1> -->
        <!-- <h1>{{ episode.guest }}</h1> -->
        <!-- <h1>{{ episode.description }}</h1> -->
        <div id="display">
          <img :src="episode.img"/>
          <!-- <iframe v-for="track in episode.embedUrl" :key="track"
          width="100%" height="20" scrolling="no" frameborder="no" allow="autoplay" :src="'https://w.soundcloud.com/player/?url=https%3A//' + track + '&color=%23000000&inverse=false&auto_play=false&show_user=true'"></iframe> -->

          <iframe v-for="track in episode.embedUrl" :key="track"
            height="130" scrolling="no" frameborder="no" allow="autoplay" :src="'https://w.soundcloud.com/player/?url=https%3A//' + track + '&color=%23101010&auto_play=false&hide_related=false&show_inverse=false&show_comments=false&show_user=false&show_artwork=false&show_reposts=false&show_teaser=false'">
          </iframe>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
var debounce = require('lodash.debounce');

export default {
  name: 'Archive',
  data() {
    return {
      scroll: false,
      inVP: null
    }
  },
  props: ['shows', 'isMobile'],
  mounted() {
    let scrollArea = document.getElementById("archive");
    scrollArea.addEventListener('scroll', debounce(this.checkVP, 200));
  },
  methods: {
    checkVP() {
      let mixObjects = document.getElementsByClassName("episodeblock");
      for (let object of mixObjects) {
        let bounding = object.getBoundingClientRect();
        if (
          (window.innerHeight / 2 || document.documentElement.clientHeight / 2) >= bounding.top && 
          (window.innerHeight / 2 || document.documentElement.clientHeight / 2) <= bounding.bottom 
        ) {
          this.$emit('VP', object.id);
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #archive {
    width:100%;
    height:100%;
    position:absolute;
    overflow-y:auto;
    right:0;
    top:0;
    padding:10%;
    background-size:cover;
    /* background-color: rgb(223, 223, 223); */
    background-position: center;

  }

  #display {
    margin:0 5px 0px 5px;
  }

  #item {
    padding:15px;
    width:350px;
    margin:auto;
    margin-top:50px;
    /* margin: 25px 0 25px 0; */
    background-color: rgb(231, 231, 231);
  }

  #item.mobile {
    width:94%;
  }

  iframe {
    width:100%;
    position:relative;
  }

  img {
    width:100%;
    height:auto;
    mix-blend-mode: multiply;
    border: 1px solid black;
  }

 
</style>
